import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { PROFILE_ROUTES } from '../utils/helpers/constants';

export enum ProfileBusinessTabsValueEnum {
  packages = 'packages',
  agency = 'agency',
  transfers = 'transfers',
  balance = 'balance',
  invoices = 'invoices'
}

export const useProfileBusinessTabsState = (isMainAgent?: boolean) => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentTabValue = router.query.tab as ProfileBusinessTabsValueEnum;

  const tabValuesArray = useMemo(
    () => [
      {
        value: ProfileBusinessTabsValueEnum.packages,
        name: t('pages.profile.packages'),
        stat: 'profile-business-packages'
      },
      {
        value: ProfileBusinessTabsValueEnum.balance,
        name: t('pages.profile.balance'),
        stat: 'profile-business-balance'
      },
      {
        value: ProfileBusinessTabsValueEnum.agency,
        name: t('pages.profile.agency'),
        stat: 'profile-business-agency',
        isShown: isMainAgent
      },
      {
        value: ProfileBusinessTabsValueEnum.transfers,
        name: t('pages.profile.transfers'),
        stat: 'profile-business-transfers',
        isShown: isMainAgent
      },
      {
        value: ProfileBusinessTabsValueEnum.invoices,
        name: t('pages.profile.invoices'),
        stat: 'profile-business-invoices'
      }
    ],
    [t, isMainAgent]
  );

  useEffect(() => {
    if (
      (currentTabValue === ProfileBusinessTabsValueEnum.agency ||
        currentTabValue === ProfileBusinessTabsValueEnum.transfers) &&
      isMainAgent === false
    ) {
      router.replace(PROFILE_ROUTES.BUSINESS_PACKAGES, undefined, {
        shallow: true
      });
    }
  }, [currentTabValue, isMainAgent]);

  const optionHandleClick = (value: ProfileBusinessTabsValueEnum) => {
    router.push(`/profile/business/${value}`, undefined, { shallow: true });
  };

  return {
    currentTabValue,
    optionHandleClick,
    tabValuesArray
  };
};
